export default {
	GET_PAYMENT_INFO: '/WxAIMusic/getPaymentInfo',
	AI_MUSIC_RECHARGE: '/WxAIMusic/aiMusicRecharge',
	CREATE_UNIFIED_ORDER: '/WxAIMusic/CreateUnifiedOrder',
	ORDER_QUERY: '/WxAIMusic/OrderQuery',
	GET_JS_SDK_CONFIG: '/WxAIMusic/GetJsSdkConfig',
	AI_TIMBRE_COMPOSITE: '/WxAIMusic/AiTimbreComposite',
};



// WEBPACK FOOTER //
// ./src/service/api/modules/aimusic.js